import { gsap } from 'gsap';


export const generalMouseMoveAnimation = (element) => {
  gsap.to(element, {
    duration: 0.2,
    scale: 1.05,
    y: -10,
    ease: 'ease-in-out',
  });
};

export const generalMouseOutAnimation = (element) => {
  gsap.to(element, {
    duration: 0.2,
    scale: 1,
    y: 0,
    ease: 'ease-in-out',
  });
};

